// extracted by mini-css-extract-plugin
export default {"root":"EmptyBasket-module_root_ac94cd","text":"EmptyBasket-module_text_a31843"};